import { GenIcon } from '../helpers/IconBase.es.js';

const ChatboxOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 512 512" },
    child: [
      {
        tag: "g",
        attr: {
          transform: "translate(256 256) scale(0.62) translate(-256 -256)"
        },
        child: [
          {
            tag: "path",
            attr: {
              d: "M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80a16 16 0 0024.84 13.29L320 368h88a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z",
              fill: "none",
              stroke: "currentColor",
              strokeLinejoin: "round",
              strokeWidth: "32"
            }
          }
        ]
      }
    ]
  })(props);
};

export { ChatboxOutlined };
